import { Box, Container, Heading, SimpleGrid } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { StyleProps } from '@chakra-ui/react';
import React from 'react';
import AboutUsHeroVector from '../../assets/svgs/AbouUsHeroVector';

const headingStyles: StyleProps = {
  gridRow: { base: 1, desktop: 'auto' },
  maxW: { base: '3xl', desktop: '2xl' },
  color: 'neutral.0',
  textAlign: { base: 'center', desktop: 'left' },
  marginBottom: { base: 500, desktop: 0 },
  mx: { base: 'auto', desktop: 0 },
};

const Hero = () => (
  <Box w="100%" bg="brandGreen.500">
    <Container maxW="8xl" py={{ base: 700, desktop: 1000 }} px={500}>
      <SimpleGrid
        columns={{ base: 1, desktop: 2 }}
        spacing={{ base: 500, desktop: 100 }}
        alignItems="center"
      >
        <Box
          h="100%"
          justifyContent="center"
          d={{ base: 'none', tablet: 'flex' }}
        >
          <Box maxW="420px" position="relative" alignSelf="center">
            <AboutUsHeroVector aria-hidden />
            <Box h="297px" w="100%" position="absolute" top="85px" left="26px">
              <StaticImage
                loading="eager"
                objectFit="contain"
                placeholder="blurred"
                alt="about-us-hero"
                src="../../assets/images/about_us_hero.png"
              />
            </Box>
          </Box>
        </Box>
        <Container px={0} centerContent d={{ base: 'flex', tablet: 'none' }}>
          <StaticImage
            loading="eager"
            placeholder="blurred"
            src="../../assets/images/about_us_page_hero.png"
            alt="about us hero image"
            width={440}
            objectFit="contain"
          />
        </Container>
        <Heading
          {...headingStyles}
          size={{ base: 600, tablet: 700, desktop: 800 }}
        >
          Our mission is to help people improve their homes with the world’s
          best 3D property data
        </Heading>
      </SimpleGrid>
    </Container>
  </Box>
);

export default Hero;
